import {observable} from 'mobx';

let instance:TabStore | null = null

export default class TabStore {
  @observable controlName:string | null

}